import { Component } from 'preact';
import { route } from 'preact-router';

import Tabs from '../../components/tabs';
import RecordsOverall from '../../components/records-overall';
import RecordsTopTen from '../../components/records-top-ten';
import RecordsMonthly from '../../components/records-monthly';
import Card from '../../components/card';
import { ABORT_ERROR_NAME, abortRequests, fetchRecords } from '../../utils/api';
import { getDateTimeFormatConverter } from '../../utils/formatters';
import { getMonthNames } from '../../utils/date-utils';
import PageTitle from '../../components/page-title';
import style from './style.scss';

class HistoryRecordsPage extends Component {

	constructor(props, context) {
		super(props, context);

		this.VIEW_ID = {
			OVERALL: 'overall',
			TOP_TEN: 'top10',
			MONTHLY: 'monthly'
		};

		this.views = [
			{
				id: this.VIEW_ID.OVERALL,
				routeView: 'overall',
				label: 'Overall'
			},
			{
				id: this.VIEW_ID.TOP_TEN,
				routeView: 'top-ten',
				label: 'Top 10'
			},
			{
				id: this.VIEW_ID.MONTHLY,
				routeView: 'monthly',
				label: 'Monthly'
			}
		];

		this.state = {
			activeViewId: null,
			records: undefined,
			recordsLoading: false,
			recordsRetryCount: -1
		};

		this.loadRecords = this.loadRecords.bind(this);

		this.requestAbort = {
			records: null
		};
	}

	navigate(viewData) {
		route('/history-records/' + viewData.routeView);
	}

	setViewFromRoute(routeView, routeSubview) {
		const viewData = this.views.filter(v => v.routeView === routeView)[0];

		let isValidView = viewData !== undefined;
		let isValidSubview;

		if (viewData && viewData.id === this.VIEW_ID.MONTHLY) {

			// Monthly records page has subview - the month names or empty string (default to current month)
			const validSubviews = getMonthNames().map(month => month.toLowerCase());
			isValidSubview = routeSubview === '' || validSubviews.indexOf(routeSubview) !== -1;

		} else {

			// Other records pages have no subviews - make sure none is set
			isValidSubview = routeSubview === '';

		}

		const isValid = isValidView && isValidSubview;

		if (isValid) {
			this.setState({ activeViewId: viewData.id });

			this.context.titleService.update(viewData.label + ' Records');
			this.context.tracking.recordPageView();
		} else {
			route('/not-found', true);
		}

		return isValid;
	}

	loadRecords() {
		this.setState({
			recordsLoading: true
		});

		const request = fetchRecords();
		this.requestAbort.records = request.abort;

		request.promise
			.then(res => {
				this.setState({
					records: res.data,
					recordsLoading: false,
					recordsRetryCount: -1
				});
			})
			.catch(err => {
				if (err.name !== ABORT_ERROR_NAME) {
					this.setState(state => ({
						records: null,
						recordsLoading: false,
						recordsRetryCount: state.recordsRetryCount + 1
					}));
					this.context.tracking.recordException('Error loading records data', err);
				}
			});
	}

	componentDidMount() {
		const isValidRoute = this.setViewFromRoute(this.props.view, this.props.subview);

		if (isValidRoute) {
			this.loadRecords();
		}
	}

	componentWillUnmount() {
		abortRequests(this.requestAbort);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.view !== this.props.view || nextProps.subview !== this.props.subview) {
			this.setViewFromRoute(nextProps.view, nextProps.subview);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return this.state !== nextState;
	}

	renderContent() {
		switch (this.state.activeViewId) {

			case this.VIEW_ID.OVERALL:
				return this.renderOverall();

			case this.VIEW_ID.TOP_TEN:
				return this.renderTopTen();

			case this.VIEW_ID.MONTHLY:
				return this.renderMonthly();
		}
	}

	renderOverall() {
		const data = this.state.records
			? this.state.records.overall
			: this.state.records;

		return (
			<RecordsOverall data={data}
			                isLoading={this.state.recordsLoading}
			                errorMessage="Unable to load records data"
			                retryCount={this.state.recordsRetryCount}
			                retryHandler={this.loadRecords} />
		);
	}

	renderTopTen() {
		const data = this.state.records
			? this.state.records.top10
			: this.state.records;

		return (
			<RecordsTopTen data={data}
			               isLoading={this.state.recordsLoading}
			               errorMessage="Unable to load records data"
			               retryCount={this.state.recordsRetryCount}
			               retryHandler={this.loadRecords} />
		);
	}

	renderMonthly() {
		const data = this.state.records
			? this.state.records.monthly
			: this.state.records;

		let month;

		if (this.props.subview !== '') {
			month = getMonthNames().map(month => month.toLowerCase()).indexOf(this.props.subview) + 1;
		} else {
			month = this.state.records
				? (new Date(this.state.records.end)).getMonth() + 1
				: null;
		}

		return (
			<RecordsMonthly data={data}
			                month={month}
			                isLoading={this.state.recordsLoading}
			                errorMessage="Unable to load records data"
			                retryCount={this.state.recordsRetryCount}
			                retryHandler={this.loadRecords} />
		);
	}

	render() {
		let dataPeriod = '---';

		if (this.state.records) {
			const transformDate = getDateTimeFormatConverter('%Y-%m-%d', '%-d %b %Y');
			dataPeriod = transformDate(this.state.records.start) + ' - ' + transformDate(this.state.records.end);
		}

		return (
			<div>
				<PageTitle>Weather Station Records</PageTitle>
				<Tabs options={this.views} selectedId={this.state.activeViewId} tabSelected={this.navigate} />
				<Card noMargin>
					{ this.renderContent() }
					<p class={style.data_period}>
						<strong>Data period:</strong> { dataPeriod }
					</p>
				</Card>
			</div>
		);
	}

}

export default HistoryRecordsPage;



// WEBPACK FOOTER //
// ./routes/history-records/index.js